import { UserInfo } from "shared/types/UserInfo"

import { SendFeedbackPayload } from "features/feedback/model/useFeedback"

export function createFeedbackMessage({
  feedbackType,
  link,
  message,
  attachments
}: SendFeedbackPayload & { userInfo?: UserInfo | null }) {
  return {
    subject: feedbackType,
    message: message || "Ohne Nachricht",
    url: link,
    attachments: attachments && attachments.length > 0 ? attachments : []
  }
}
